import { colors } from "../../../../styles/colors"
import { fonts, fontSizes } from "../../../../styles/fonts"

const outerWrapper: any = {
    width: 880,
    height: 753,
    backgroundColor: colors.white,
    zIndex: 13,
    borderRadius: 10,
    position: 'fixed',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    trasition: 'all 0.2s ease-in',
    display: 'flex',
    flexFlow: 'column'
}

const filterSearchWrapper = {
    display: 'flex',
    justifyContent: 'space-between',
    height: 36,
}

const filterWrapper = {
    display: 'flex',
    alignItems: 'center',
    color: colors.darkerGrey,
    fontSize: fontSizes.xsmall + 1,
}

const header = {
    padding: '30px 35px 16px 35px',
    borderBottom: `1px solid ${colors.dullGrey}`
}

const cardTitle = {
    fontFamily: fonts.mediumFont,
    color: '#000',
    fontSize: fontSizes.xxlarge,
    marginBottom: 16
}

const footer = {
    padding: '30px 35px',
    borderTop: `1px solid ${colors.dullGrey}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
}

const ctaWrapper = {
    display: 'flex',
    alignItems: 'center'
}

const createPlanCta = {
    fontFamily: fonts.mediumFont,
    fontSize: fontSizes.medium,
    marginLeft: 9
}

const plansList = {
    flex: 1,
    marginTop: 6,
    minHeight: 90
}

const actionButton = {
    padding: "10px 34px"
}

const tableWrapper = {
    width: "100%",
    background: colors.white,
}

const tableHeader = {
    color: colors.slateBlue,
    fontFamily: fonts.mediumFont,
    fontSize: fontSizes.small,
    background: colors.white,
    borderRadius: 0,
    'th': {
        border: 'none'
    },
    borderBottom: '0.5px solid #eee'
}

const tableData = {
    color: colors.black,
    background: colors.white,
    'td': {
        border: 'none',
    },
    '&:nth-of-type(2n)': {
        backgroundColor: '#f5f6f7'
    },
    borderBottom: '0.5px solid #eee'
}


const smallCol = {
    width: '15%',
    padding: "10px 15px"
}

const smallerCol = {
    width: '10%',
    padding: "10px 15px"
}

const bigCol = {
    width: '30%',
    padding: "10px 15px"
}


const dataRow: any = {
    borderTop: "15px solid #fafbfc",
    cursor: "pointer",
    overflow: 'hidden',
    whiteSpace: 'nowrap',
}

const absoluteCenter = {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)'
}

const notFound: any = {
    ...absoluteCenter,
    textAlign: "center",
    padding: 20,
    fontSize: 16,
    color: colors.black,

}

const capitalize: any = {
    textTransform: 'capitalize'
}

const searchingWrapper: any = {
    ...absoluteCenter,
    'img': {
        height: 50,
        width: 50,
    }
}

const customSelectWrapper = {
    width: 70,
    marginLeft: 11
}


export {
    outerWrapper,
    tableWrapper,
    actionButton,
    plansList,
    tableData,
    tableHeader,
    dataRow,
    notFound,
    header,
    cardTitle,
    footer,
    ctaWrapper,
    smallCol,
    smallerCol,
    bigCol,
    filterSearchWrapper,
    capitalize,
    filterWrapper,
    createPlanCta,
    searchingWrapper,
    customSelectWrapper
}